<div id="{{gdFieldId}}Question" *ngIf="gdShowFlag" 
	[ngClass]="gdAddClass" class="febi-tag enable-pointer-events {{gdDisableHook}}">

	<label *ngIf="gdShowLabel" [attr.for]="gdFieldId" id="{{gdFieldId}}GroupLabel" [ngClass]="gdHideLabel" [innerHTML]="gdLabel"></label>
	
	<div class="inputBlock">
		<div class="select">
			
			<select name="{{gdFieldId}}" id="{{gdFieldId}}" class="" [ngClass]="{'select-nextgen': gdStyleNextGen}" [(ngModel)]="gdModel" [disabled]="gdDisabled"
				(ngModelChange)="outputGdModel()"
				(keydown.Tab)="onTab()" [attr.aria-labelledby]="ariaLabelledby"
				(focus)="onFocus()"
				autocomplete="off">
				<option
					*ngFor="let option of gdOptions"
					[attr.disabled]="option.disabled ? '' : null"
					[attr.hidden]="option.hidden ? '' : null"
					value="{{option.value}}">{{option.display}}</option>
			</select>
		
		</div>
	</div>
	
</div>